import React from 'react';
import './styles.css';
import { Col, Button } from 'antd';
import { CommentsList, CommentForm, RBAC } from '@BUP/components';
import { useAuth } from '@BUP/hooks';
import { useTranslation } from 'react-i18next';

const ChatBox = ({
  messageCreator,
  isCaseOpen,
  onOpenMainMessage,
  messages,
  isLoading,
  onSendMessage,
  chatContainerRef,
  fatherMessage,
  onClickUpdateMessages,
}) => {
  const { user } = useAuth();
  const [t] = useTranslation();

  return (
    <Col className="chatbox-container" xs={24} lg={20} xxl={18}>
      <div className={`title-wrapper ${!isCaseOpen && 'title-dark'}`}>
        {messageCreator}
      </div>
      <div className={`chat-content ${!isCaseOpen && 'content-dark'}`}>
        <CommentsList
          comments={messages}
          user={user}
          isLoading={isLoading}
          chatContainerRef={chatContainerRef}
          isCaseOpen={isCaseOpen}
        />
        {isCaseOpen ? (
          <CommentForm
            onSendMessage={onSendMessage}
            onClickUpdateChat={onClickUpdateMessages}
          />
        ) : (
          <RBAC name="openOrCloseMessageButton">
            <div className="active-case-wrapper">
              <Button
                type="primary"
                shape="round"
                size="large"
                ghost
                style={{ fontWeight: 'bold' }}
                onClick={() => onOpenMainMessage(fatherMessage.id)}
              >
                {t('pages.modeBup.chatbox.buttonText')}
              </Button>
            </div>
          </RBAC>
        )}
      </div>
    </Col>
  );
};

export default ChatBox;
